export default __webpack_public_path__ + "static/media/chair.f5293dc2.png";